import React, { useEffect, useState } from "react";
import {
  Layout,
  Space,
  Select,
  PageHeader,
  Modal
} from "antd";

import {  ExclamationCircleOutlined} from "@ant-design/icons";
import R2Footer from "../../../components/Footer";
import "./styles.scss";

import Dine from "./Dine";
import timeZoneFile from './timeZone.json';
import SettingsService from "../../../services/SettingsService";
import { useSelector } from "react-redux";

const { Content } = Layout;
const { Option } = Select;
const { confirm} = Modal

const HoursOfOperation = (props) => {

  
  const adminRestaurant = useSelector((state) => state.admin);
  const today = new Date()
  const tomorrow = new Date()

  tomorrow.setDate(tomorrow.getDate() + 1)

  const [dineTime, setDineTime] = useState([])
  const [holidayRest, setHolidayRest] = useState([])
  const [timeZone, setTimeZone] = useState(timeZoneFile)
  const [disableDine, setDisableDine] = useState(true);
  const [resSettings, setResSettings] = useState({use_dine_in_hours: true});


  const showConfirm = (isdine) => {
    confirm({
      title: `${isdine ? "Are you sure you would like to use the same hours of operation as Dine-in?"  :
      'Are you sure you would like to have different hours for Online ordering compared to Dine-in?'}`,
      icon: <ExclamationCircleOutlined />,
      content: '',
      okText: "Yes",
      cancelText: "No",
      onOk() {    
        saveResSettings(isdine);
        const payload = dineTime?.filter(item=> item.day_type === "DINE-IN")?.map(item=>{
          const obj = {
            day:item.day,
            day_start_time:item.day_start_time,
            day_end_time: item.day_end_time,
            day_type:item.day_type
          }
          return obj;
        })
        const upsertDine = SettingsService.upsertOperatingHours(adminRestaurant,payload)
        const payloadHoliday = holidayRest?.filter(item=> item.day_type === "DINE-IN")?.map(item=>{
          const obj = {
            date:item.date,
            month: item.month,
            day_type:item.day_type
          }
          return obj;
        })
        const upsertHoliday = SettingsService.upsertHolidays(adminRestaurant,payloadHoliday)
      },
      onCancel() {
        // setDisableDine(false);
      },
    });
  };
  
  const onChange = async(value,children) => {
    const paylod={
      //  setting_type: children.key,
       timezone : children.key+": "+children.value
    }
    const data = await SettingsService.updateTimezone(paylod)
  }
  const saveResSettings = (isDine) => {
    const paylod={
      use_dine_in_hours : isDine
    }
    SettingsService.updateTimezone(paylod).then(()=>{
      getResSettings();
    })
  }
  const getResSettings = async() => {
    const data = await SettingsService.getRestaurentSettings();
    setResSettings(data);
  };

  useEffect(()=>{
    getOperatingHours();
    getResSettings();
  },[])

  const getOperatingHours = async()=>{
    const data = await SettingsService.getOperatingHours(adminRestaurant)
    if(data)
      {
        const updatedTime = data.map(item =>{ return {isExisting:true,...item}})
        setDineTime(updatedTime)
      }
    const dataHoliday = await SettingsService.getHolidays(adminRestaurant)
 if(dataHoliday && dataHoliday?.length>0)
  {
    // const holiday = dataHoliday.map(item => new Date(item.date))
    setHolidayRest(dataHoliday)
  }
  }

 
  
  
  return (
    <Layout className="u-page-layout">
      <Content className="page-padding">
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          <PageHeader
            title="Hours of Operation"
            className="page-header"
            style={{ background: "#f0f2f5" }}
            extra={[
              <div>

                <Select className="select-timezone" style={{ width: 200, marginRight: "25px" }} onChange={onChange}
                  placeholder="Select timezone">
                  {timeZone && timeZone.map(item => <Option key={item.value} value={item.abbr}>{item.value}</Option>)}


                </Select>
              </div>
            ]}
          />
          <div>
        
            <Dine adminRestaurant={adminRestaurant} dineTimeRest={dineTime}
            type={"DINE-IN"}
            resSettings={resSettings}
            holidayRest={holidayRest}/>
            <Dine isDine showConfirm={showConfirm}
            adminRestaurant={adminRestaurant}
            type={"ONLINE"}
            resSettings={resSettings}
            disableDine={resSettings.use_dine_in_hours}/>

          </div>
        </Space>
      </Content>
      <R2Footer />
    </Layout>
  );
};


export default HoursOfOperation;
